import { render, staticRenderFns } from "./dataSafeApi.vue?vue&type=template&id=1d5c5ee4&scoped=true"
import script from "./dataSafeApi.vue?vue&type=script&lang=js"
export * from "./dataSafeApi.vue?vue&type=script&lang=js"
import style0 from "./dataSafeApi.vue?vue&type=style&index=0&id=1d5c5ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c5ee4",
  null
  
)

export default component.exports